export const MEETING_NOTE_TYPES = {
  GENERAL: 'general',
};
